import type { ReactElement } from 'react';
import { createStore } from 'zustand';

import type { DefaultSectionConfig } from '../customisable-form/hooks/useSectionManager';

export type FieldElement = {
  key: string;
  value: ReactElement<{ condition?: unknown } & Record<string, unknown>>;
};

export interface FormFieldElementsState {
  elements: FieldElement[];
  /**
   * Hardcoded default sections synthesised from `<DefaultSection>` markers in
   * the active form. Empty when the form declares no defaults. Consumed by the
   * form editor so its initial section layout matches the rendered form.
   */
  defaultSections: DefaultSectionConfig[];
  setElements: (elements: FieldElement[]) => void;
  setDefaultSections: (defaultSections: DefaultSectionConfig[]) => void;
  clear: () => void;
}

export type FormFieldElementsStore = ReturnType<
  typeof createFormFieldElementsStore
>;

export const createFormFieldElementsStore = () =>
  createStore<FormFieldElementsState>((set) => ({
    elements: [],
    defaultSections: [],
    setElements: (elements) => set({ elements }),
    setDefaultSections: (defaultSections) => set({ defaultSections }),
    clear: () => set({ elements: [], defaultSections: [] }),
  }));
